// Calculates the internal rate of return
export const calculateIRR = function (
  monthlyTerms: number,
  monthlyCost: number,
  startupFee: number,
  loanAmount: number,
  irr0: number,
  iterations: number
) {
  const sum = monthlyTerms * monthlyCost + startupFee;
  let irr1 = irr0;
  for (let i = 0; i < iterations; i++) {
    const rInv = 1.0 / (1.0 + irr1 / 12.0);
    const npv =
      startupFee +
      (monthlyCost * (Math.pow(rInv, monthlyTerms + 1) - rInv)) / (rInv - 1.0);
    irr1 = (irr1 * Math.log(loanAmount / sum)) / Math.log(npv / sum);
  }
  return irr1;
};

export const getLoanCost = (
  loanAmount: number,
  loanDuration: number,
  interest: number,
  monthlyFee = 0,
  startupFee = 0
) => {
  const monthlyTerms = loanDuration * 12;
  const termInterest = interest / 12;

  const monthlyPayment =
    Math.round(
      (loanAmount * termInterest) /
        (1.0 - Math.pow(1.0 + termInterest, -monthlyTerms))
    ) === 0
      ? Math.round(
          (loanAmount * termInterest) /
            (1.0 - Math.pow(1.0 + termInterest, -monthlyTerms))
        )
      : Math.round(
          (loanAmount * termInterest) /
            (1.0 - Math.pow(1.0 + termInterest, -monthlyTerms))
        ) + monthlyFee;

  const irr = calculateIRR(
    monthlyTerms,
    monthlyPayment + monthlyFee,
    startupFee,
    loanAmount,
    interest * 2,
    4
  );

  const effInterest = Math.pow(irr / 12 + 1, 12) - 1;
  const cost = monthlyPayment * monthlyTerms + startupFee;

  return {
    totalCost: cost,
    monthlyPayment: monthlyPayment,
    effectiveInterest: effInterest,
    nominalInterest: interest,
    loanAmount: loanAmount,
    loanDuration: loanDuration,
  };
};
